import { useQuery } from "@tanstack/react-query";
import { getReportTopCategories } from "../../api/apiReports";

export const useGetReportTopCategories = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["report-top-categories", params],
        queryFn: () => getReportTopCategories(params),
        retry: false,
    });

    return {
        items: data?.data || [],
        isLoading,
        error,
        refetch,
    };
};
